<app-metformin
  htmlTitle="<strong>Support</strong> Metabolic Health for Better Hair Growth"
  question="We strongly recommend including Metformin in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Hair loss isn’t just genetic. Metabolic health and inflammation can quietly affect hormone signaling and hair
    follicle function. Fortunately, there’s a trusted way to support this: <strong>Metformin</strong>.
  </p>
  <p class="mb-4">
    By adding <strong>Metformin</strong> to your treatment plan, you can help improve blood sugar balance and reduce
    inflammation—factors that may help your hair loss treatment work more effectively over time.
  </p>
  <p class="mb-4">
    Metformin is a <strong>safe, well-studied medication</strong> with decades of proven use and an excellent safety
    profile.
  </p>
</app-metformin>
